import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';
import { AppRoutingModule } from '../app-routing.module';
import { MessageService } from 'primeng/api';

import { MatTabsModule } from '@angular/material/tabs';

import { StaffRoutingModule } from './staff.routing.module';
import { StaffMainComponent, StaffHomeComponent } from './';
import { BoxFrequencyComponent } from './home/box-frequency/box-frequency.component';
import { BoxDurationComponent } from './home/box-duration/box-duration.component';
import { BoxDttComponent } from './home/box-dtt/box-dtt.component';
import { BoxQuantityComponent } from './home/box-quantity/box-quantity.component';
import { BoxFluencyrateComponent } from './home/box-fluencyrate/box-fluencyrate.component';
import { BoxRateComponent } from './home/box-rate/box-rate.component';
import { BoxAnecdotalComponent } from './home/box-anecdotal/box-anecdotal.component';
import { BoxEchoicComponent } from './home/box-echoic/box-echoic.component';
import { PatientSessionService } from './home/patient-session.service';
import { BoxBehaviorFrequencyComponent } from './home/box-behavior-frequency/box-behavior-frequency.component';
import { EndSessionComponent } from './home/end-session/end-session.component';
import { TargetSelectorComponent } from './home/target-selector/target-selector.component';
import { ABCDataPanelComponent } from './home/abc-data-panel/abc-data-panel.component';
import { BoxBehaviorDurationComponent } from './home/box-behavior-duration/box-behavior-duration.component';
import { SessionsComponent } from './sessions/sessions.component';
import { SessionServiceSelectComponent } from './sessions/session-service-select/session-service-select.component';
import { SessionComponent } from './sessions/session/session.component';
import { ViewSessionComponent } from './sessions/view-session/view-session.component';
import { GraphsModule } from '../graphs/graphs.module';
import { ProgressNoteComponent } from './home/progress-note/progress-note.component';
import { TargetDetailsComponent } from './home/target-details/target-details.component';
import { BoxGroupedComponent } from './home/box-grouped-frequency/box-grouped.component';
import { BoxIntervalComponent } from './home/box-interval/box-interval.component';
import { BoxToiletingComponent } from './home/box-toleting/box-toileting.component';
import { BoxBehaviorIntervalComponent } from './home/box-behavior-interval/box-behavior-interval.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { AddDataComponent } from './sessions/add-data/add-data.component';
import { AddBehaviorDataComponent } from './sessions/add-behavior-data/add-behavior-data.component';
import { AddTargetDataComponent } from './sessions/add-target-data/add-target-data.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BoxBehaviorRatetimerComponent } from './home/box-behavior-ratetimer/box-behavior-ratetimer.component';
import { BoxBehaviorIntensityComponent } from './home/box-behavior-intensity/box-behavior-intensity.component';
import { BoxTargetIntensityComponent } from './home/box-target-intensity/box-target-intensity.component';
import { BehaviorBipInfoComponent } from '../supervisor/behaviors/behavior-bip-info/behavior-bip-info.component';
import { BipQuickReferenceComponent } from '../supervisor/bip/bip-quick-reference/bip-quick-reference.component';
import { BipBehaviorsComponent } from '../supervisor/bip/bip-behaviors/bip-behaviors.component';
import { BipCrisisCycleComponent } from '../supervisor/bip/bip-crisis-cycle/bip-crisis-cycle.component';
import { BipEmergencyProceduresComponent } from '../supervisor/bip/bip-emergency-procedures/bip-emergency-procedures.component';
import { BipAdditionalInfoComponent } from '../supervisor/bip/bip-additional-info/bip-additional-info.component';
import { TargetInfoComponent } from './home/target-info/target-info.component';
import { BoxCurrencyComponent } from './home/box-currency/box-currency.component';
import { GroupSessionComponent } from './group-session/group-session.component';
import { TargetNoteThreadComponent } from '../shared/components/target-note-thread/target-note-thread.component';

function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(
      `${moduleName} has already been loaded. Import Core modules in the AppModule only.`
    );
  }
}

const pages = [StaffMainComponent, StaffHomeComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    StaffRoutingModule,
    MatTabsModule,
    GraphsModule,
    OverlayPanelModule,
    TableModule,
    ToolbarModule,
    FileUploadModule,
    MultiSelectModule,
    InputNumberModule,
    SelectButtonModule,
    BehaviorBipInfoComponent,
    BipQuickReferenceComponent,
    BipBehaviorsComponent,
    BipCrisisCycleComponent,
    BipEmergencyProceduresComponent,
    BipAdditionalInfoComponent,
    TargetNoteThreadComponent,
  ],
  declarations: [
    ...pages,
    BoxFrequencyComponent,
    BoxDurationComponent,
    BoxDttComponent,
    BoxQuantityComponent,
    BoxFluencyrateComponent,
    BoxRateComponent,
    BoxAnecdotalComponent,
    BoxEchoicComponent,
    BoxBehaviorFrequencyComponent,
    EndSessionComponent,
    BoxGroupedComponent,
    TargetSelectorComponent,
    ABCDataPanelComponent,
    BoxBehaviorDurationComponent,
    SessionsComponent,
    SessionServiceSelectComponent,
    SessionComponent,
    ViewSessionComponent,
    ProgressNoteComponent,
    TargetDetailsComponent,
    BoxIntervalComponent,
    BoxToiletingComponent,
    BoxBehaviorIntervalComponent,
    AddDataComponent,
    AddBehaviorDataComponent,
    AddTargetDataComponent,
    BoxBehaviorRatetimerComponent,
    BoxBehaviorIntensityComponent,
    BoxTargetIntensityComponent,
    BoxCurrencyComponent,
    TargetInfoComponent,
    GroupSessionComponent,
  ],
  exports: [AddDataComponent, AddBehaviorDataComponent, AddTargetDataComponent],
  bootstrap: [],
})
export class StaffModule {
  constructor(@Optional() @SkipSelf() parentModule: StaffModule) {
    if (parentModule) {
      throw new Error(
        'Module is already loaded. Import in your base AppModule only.'
      );
    }
  }
}
